import ReactScrollLock from 'react-scrolllock'

import { isServer } from '/javascripts/checks'

export const ScrollLock = () => {
  if (isServer) return null

  return <ReactScrollLock />
}
